import { PaymentGatewayType } from '../core/systemTypes';

export type PromoterFullInfoType = {
  paymentGatewaySettings: PaymentGatewayType[];
  billingAddressSameAsContact: boolean;
  id: string;
  name: string;
  about: string;
  url: string;
  email: string;
  mobileNumber: string;
  telephoneNumber: string;
  address: string;
  town: string;
  postcode: string;
  currency?: string;
  country: string;
  iframeStyles: string;
  ibanNumber: string;
  bankHolderName: string;
  billingName: string;
  billingAddress: string;
  billingTown: string;
  billingCountry: string;
  billingPostcode: string;
  billingVATNumber: string;
  canEdit: boolean;
  logo: string;
};

export type ReferrerLinkReqType = {
  email: string;
  promoterId: string;
  referrerLink: string;
  groupIds?: string[];
};

export type ReferrerEditLinkReqType = {
  email: string;
  promoterId: string;
  referrerLink: string;
  groupIds: string[];
  id: string;
};

export type ReferralLinkResType = {
  referrerLink: string;
  qtyOfTicketsReferred: number;
  valueOfTicketsReferred: number;
  currency: string;
  id: string;
  user: {
    firstName: string;
    lastName: string;
    userEmail: string;
    userId: string;
    profilePic: string;
  };
  promoter: {
    promoterId: string;
    promoterName: string;
  };
  metrics: {
    qtyOfTicketsReferred: number;
    valueOfTicketsReferred: number;
    currency: string;
    eventName: string;
  }[];
  groups: {
    name: string;
    id: string;
    colour: string;
  }[];
};

export type ReferrerResType = {
  nextPage: number;
  previousPage: number;
  pageSize: number;
  pageNumber: number;
  totalPages: number;
  totalRecords: number;
  totalRecordsInPage: number;
  referrers: Referrer[];
};

export type ReferrerReqType = {
  PromoterId: string;
  Term?: string;
  Type?: ReferrerEnum;
  PageNumber: number;
  PageSize: number;
};

export enum ReferrerEnum {
  ALL = 'All',
  MOST_SALES = 'MostSales',
}

export type Referrer = {
  referrerLink: string;
  qtyOfTicketsReferred: number;
  valueOfTicketsReferred: number;
  currency: string;
  id: string; // UUID format
  user: {
    firstName: string;
    lastName: string;
    userEmail: string;
    userId: string; // UUID format
    profilePic: string;
  };
  promoter: {
    promoterId: string; // UUID format
    promoterName: string;
  };
};

export type ReferrerGroupReqType = {
  name: string;
  promoterId: string;
  colour: string;
};

export type ReferrerGroupEditReqType = {
  name: string;
  promoterId: string;
  colour: string;
  id: string;
};

export type ReferrerGroupResType = {
  name: string;
  id: string;
  colour: string;
  promoter: {
    promoterId: string;
    promoterName: string;
  };
};

export type ReferrerFilterType = {
  PageNumber?: number;
  PageSize?: number;
  Term?: string;
  Type: ReferrerEnum;
};

export type ReferrerItemResType = {
  referrerLink: string;
  qtyOfTicketsReferred: number;
  valueOfTicketsReferred: number;
  currency: string;
  user: {
    firstName: string;
    lastName: string;
    userEmail: string;
    userId: string; // UUID format
    profilePic: string;
  };
  promoter: {
    promoterId: string; // UUID format
    promoterName: string;
  };
  metrics: {
    qtyOfTicketsReferred: number;
    valueOfTicketsReferred: number;
    currency: string;
    eventName: string;
  }[];
  groups: {
    name: string;
    id: string; // UUID format
    colour: string;
  }[];
};
